import React, { useState, useEffect } from 'react';
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn';
import { useHistory } from 'react-router-dom';
import ReactDataGrid from '@inovua/reactdatagrid-enterprise';
import PageSubTitle from '../../component/Common/PageSubTitle';

const GRID_STYLE = { minHeight: 622, width: '100%' };

const DEFAULT_FILTER_VALUE = [
    { name: 'measure_name', operator: 'contains', type: 'string', value: '' },
    { name: 'description', operator: 'contains', type: 'string', value: '' },
    { name: 'source', operator: 'contains', type: 'string', value: '' },
    { name: 'effective_from_date', operator: 'contains', type: 'string', value: '' },
];

const DashboardInternal = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const history = useHistory();

    const ReportHeaders = [
        { name: 'measure_name', header: 'Report', defaultFlex: 1, resizable: true, minWidth: 150 },
        { name: 'description', header: 'Description', defaultFlex: 1, resizable: true, minWidth: 150 },
        { name: 'source', header: 'Source', defaultFlex: 1, resizable: true, minWidth: 150 },
        { name: 'effective_from_date', header: 'Effective From Date', defaultFlex: 1, resizable: true, minWidth: 150 },
        { name: 'trend', header: 'Trend', defaultFlex: 1, resizable: true, minWidth: 150 },
    ];

    const reportResponseList = [
        {
            key: 1,
            measure_id: 'ReviewerGroupsEffeciencyAnalysis',
            measure_name: 'Reviewer Groups Effeciency Analysis',
            description: 'Overview of reviewer groups performance in terms of reviews completed within allocated business days, beyond and not completed reviews',
            source: 'NEMCIS Tracking and Monitoring',
            effective_from_date: '5/5/2025',
            trend: '',
        },
        {
            key: 2,
            measure_id: 'PlanPendingReview',
            measure_name: 'Plan Pending Review',
            description: 'Plan-wise pending reviews for a period',
            source: 'NEMCIS Tracking and Monitoring',
            effective_from_date: '5/5/2025',
            trend: '',
        },
    ];

    const handleRowClick = (data: any) => {
        history.push({
            pathname: '/internal-work-management-details',
            state: { recordData: data },
        });
    };

    useEffect(() => {
        try {
            setIsLoading(true);
            // Simulate data fetching
            setTimeout(() => setIsLoading(false), 1000);
        } catch (err) {
            setError('Failed to load data');
            setIsLoading(false);
        }
    }, []);

    if (error) {
        return <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>;
    }

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="Internal Work Management Reporting" />
                </div>
            </div>
            <div className="form-layout">
                {isLoading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading...</p>
                    </div>
                ) : reportResponseList.length > 0 ? (
                    <ReactDataGrid
                        licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                        idProperty="key"
                        style={GRID_STYLE}
                        pagination
                        virtualized
                        columns={ReportHeaders}
                        dataSource={reportResponseList}
                        sortable={true}
                        defaultLimit={10}
                        defaultFilterValue={DEFAULT_FILTER_VALUE}
                        rowHeight={50}
                        onRowClick={({ data }) => handleRowClick(data)}
                        className="pointer-cursor-row"
                        enableColumnAutosize={true}
                        pageSizes={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    />
                ) : (
                    <p style={{ textAlign: 'center', marginTop: '20px' }}>No data available</p>
                )}
            </div>
            <Footer />
        </>
    );
};

export default DashboardInternal;